import { AxiosError } from 'axios'
import i18n from 'i18n'

export type NetworkErrorType =
  | 'bad_request'
  | 'unauthorized_error'
  | 'not_found'
  | 'validation_error'
  | 'server_error'
  | 'forbidden_error'
  | 'conflict_error'

export type CustomErrorType = 'email_exists' | 'phone_exists'

export abstract class RequestError extends Error {
  static parseError(error: unknown) {
    const defaultMessage = i18n.t('common:errors.unknownErrorTitle')
    if (error instanceof RequestError) {
      return {
        type: error.type,
        detail: error.detail || defaultMessage,
        errors: error.errors,
      } as const
    }
    return {
      type: 'unknown',
      detail: i18n.t('common:errors.unknownErrorTitle'),
    } as const
  }
  method?: string
  url?: string
  code?: number
  params?: any

  detail?: string
  errors: Record<string, string> = {}
  error?: string

  public abstract readonly type: NetworkErrorType
  protected constructor(e: AxiosError) {
    super(e.name)

    const errors = e.response?.data.errors
    if (errors) this.errors = errors

    const error = e.response?.data.error
    if (error) this.error = error

    const detail = e.response?.data.detail
    this.detail = typeof detail === 'string' ? detail : e.response?.data.message

    this.url = e.config.url
    this.code = e.response?.status
    this.method = e.config.method
    this.params = e.config.params
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export class BadRequestError extends RequestError {
  readonly type = 'bad_request'

  constructor(e: AxiosError) {
    super(e)
    // TODO Fix this sh*t
    if (e.response?.data.error && e.response?.data.error !== this.type) {
      this.type = e.response?.data.error
    }
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export class UnauthorizedError extends RequestError {
  readonly type = 'unauthorized_error'

  constructor(e: AxiosError) {
    super(e)
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export class NotFoundError extends RequestError {
  readonly type = 'not_found'

  constructor(e: AxiosError) {
    super(e)
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export class ValidationError extends RequestError {
  readonly type = 'validation_error'

  constructor(e: AxiosError) {
    super(e)

    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export class ForbiddenError extends RequestError {
  readonly type = 'forbidden_error'

  constructor(e: AxiosError) {
    super(e)
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export class ConflictError extends RequestError {
  readonly type = 'conflict_error' as const
  constructor(e: AxiosError) {
    super(e)
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
